<template>
	<div class="mobile-layout">
		<div class="custom-nav-bar">
			<div class="custom-nav-bar-content  tn-flex tn-flex-col-center tn-flex-row-between">
				<div class="logo tn-margin-left tn-flex-1 tn-flex tn-flex-col-center tn-flex-row-left"><img
						style="width: 32px;" src="@/assets/logo.svg"></div>
				<!-- <div class="wallet-connect">0xEBC6…13FB</div> -->
				<div class="lang-change">
					<div class=" tn-flex tn-flex-row-center" @click="showLangSelect">
						<span>{{language}}</span>
						<img style="width: 16px;margin-left: 10px;" src="@/assets/drop.svg">
					</div>
					<div class="language-popover" v-show="showLangList">
						<div class="lang-item" @click="selectLang('zh-cn')">中文</div>
						<div class="lang-item" @click="selectLang('en')">EN</div>
					</div>
				</div>
				<div class="menu tn-flex tn-flex-col-center tn-flex-row-center tn-margin-right"><img style="width: 24px;"
						src="@/assets/menu.svg"></div>
			</div>
		</div>
		<router-view />
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	export default {
		data: () => ({
			showLangList:false,
			lang: localStorage.getItem("lang")
		}),
		computed: {
			...mapState(['walletAddress']),
			language(){
				if(!this.lang){
					this.lang = this.$appConfig.defaultLang;
				}
				console.log(this.lang)
				return this.$appConfig.langConfig[this.lang];
			}
		},
		methods:{
			showLangSelect(){
				this.showLangList = true;
			},
			selectLang(lang){
				this.showLangList = false;
				if(this.lang == lang) return;
				window.localStorage.setItem("lang",lang);
				this.lang = lang;
				// if( this.lang == "en" ){
				// 	window.localStorage.setItem("lang","zh-cn");
				// 	this.lang = 'zh-cn';
				// }else{
				// 	window.localStorage.setItem("lang","en");
				// 	this.lang = 'en';
				// }
				window.location.reload();
			}
		}
	};
</script>

<style lang="less">
	// 引入Vant移动端样式
	@import '../styles/theme.less';
	@import '../styles/commons.less';
	@import '~vant/lib/index.less';
	@import '../styles/mobile.less';
</style>